
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Update, GetById } from "adminApi/UserManageApi/UserManage";
import { validateForm } from "utils/validation";
import { UserEditRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditUserForm from "./Componates/EditUserForm";
import fields from "../json/UserLisrFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import RoleFetcher from "Common/FetchRolePermission";
import { setMenuAccess, removeMenuAccess, removeMenuList } from "../../../Redux/actions/settingsActions";

const Useredit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user);
  const { formdata } = fields;
  const { id } = useParams();

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors, setValues } = useFormChange(
    initialValues,
    UserEditRules
  );

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      if (typeof (vals.image) == "string") {
        delete vals.image
      }
      const err = validateForm(vals, UserEditRules)
      setErrors(err);
      return err;
    },
    () => {
      if (Number(userInfo?.id) === Number(id)) {
        console.log("userInfo", userInfo);
        dispatch(removeMenuList());
        RoleFetcher({ dispatch, user: userInfo, setMenuAccess, removeMenuAccess });
      }
      navigate(-1);
    },
    "Update user successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditUserForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        title="Update User"
        handleFileChange={handleFileChange}
      />
    </>
  );
};

export default Useredit;
